import api from './api';

const path = eventId => `/event/${encodeURIComponent(eventId)}/sponsors`;
export const getEventSponsors = eventId => api.get(path(eventId)).then(response => response.data);
export const uploadSponsorLogo = (eventId, imageBase64) => api.post(`${path(eventId)}/uploads`, { imageBase64 }).then(response => response.data);
export const saveEventSponsors = (eventId, payload) => api.post(path(eventId), payload).then(response => response.data);

export const createSaveAttempt = (revision, saveId, sponsors) => ({
    revision, saveId, sponsors: sponsors.map(sponsor => ({ ...sponsor })), uploads: {}, payload: null,
});

// The caller retains this attempt after failure. Once assembled, its payload is never
// changed: a response lost after committing is retried with the exact same saveId/body.
export const runSaveAttempt = async (eventId, attempt, onProgress = () => {}) => {
    if (!attempt.payload) {
        const pending = attempt.sponsors.filter(sponsor => sponsor.imageBase64);
        let completed = 0;
        for (const sponsor of pending) {
            onProgress({ completed, total: pending.length + 1 });
            const uploaded = attempt.uploads[sponsor.id];
            if (!uploaded || Date.parse(uploaded.expiresAt) <= Date.now()) {
                attempt.uploads[sponsor.id] = await uploadSponsorLogo(eventId, sponsor.imageBase64);
            }
            completed += 1;
        }
        attempt.payload = {
            revision: attempt.revision,
            saveId: attempt.saveId,
            sponsors: attempt.sponsors.map(sponsor => ({
                id: sponsor.id,
                name: sponsor.name.trim(),
                ...(sponsor.websiteUrl?.trim() ? { websiteUrl: sponsor.websiteUrl.trim() } : {}),
                ...(sponsor.imageBase64 ? { uploadId: attempt.uploads[sponsor.id].uploadId } : {}),
            })),
        };
    }
    onProgress({ completed: 1, total: 2, publishing: true });
    try {
        return await saveEventSponsors(eventId, attempt.payload);
    } catch (error) {
        // A conflict may also be a successful first request whose response was lost.
        // If this read fails, retain the exact attempt and let the user retry safely.
        try {
            const current = await getEventSponsors(eventId);
            if (current.saveId === attempt.saveId) return current;
        } catch { /* Keep the original save error, not the reconciliation error. */ }
        throw error;
    }
};
